import { createContext, type ReactNode, useContext } from "react";

import { useAtdPreferences } from "./useAtdPreferences";

type AtdPreferencesContextValue = ReturnType<typeof useAtdPreferences>;

const AtdPreferencesContext = createContext<AtdPreferencesContextValue | null>(
  null,
);

export const AtdThemeProvider = ({ children }: { children: ReactNode }) => {
  const value = useAtdPreferences();
  return (
    <AtdPreferencesContext.Provider value={value}>
      {children}
    </AtdPreferencesContext.Provider>
  );
};

export const useAtdThemeContext = (): AtdPreferencesContextValue => {
  const value = useContext(AtdPreferencesContext);
  if (!value) {
    throw new Error("useAtdThemeContext must be used within AtdThemeProvider");
  }
  return value;
};

export const AtdPreferencesProvider = AtdThemeProvider;
export const useAtdPreferencesContext = useAtdThemeContext;
